/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Sections/Section/ImageTitle/Content/Content"
  
}) {
let patientImageValueData = fromData.useDataFormat({ viewPath,
context: 'patient_image',
format: fromFormat.getImageSeriesAndImageName,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient_image"
 format="/Data/format.js getImageSeriesAndImageName"
 text={patientImageValueData}
/>
</div>
{children}
</React.Fragment>)
}